import { render, staticRenderFns } from "./quickPayWallet.vue?vue&type=template&id=b29630aa&scoped=true"
import script from "./quickPayWallet.vue?vue&type=script&lang=js"
export * from "./quickPayWallet.vue?vue&type=script&lang=js"
import style0 from "./quickPayWallet.vue?vue&type=style&index=0&id=b29630aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b29630aa",
  null
  
)

export default component.exports